import classNames from 'classnames'
import { Text, TitleMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  className?: string
  newPifLayout?: boolean
}

export function YoungWashingtonWhyPif({ className }: Props) {
  const { t } = useTranslate('pif')

  return (
    <div className={classNames('flex flex-col gap-4', className)}>
      <TitleMD weight="bold" className="md:!font-semibold">
        {t('whyShouldIPayItForward', 'Why Should I Pay it Forward?')}
      </TitleMD>
      <Text color="core-gray-700" className="photon-paragraph-sm md:photon-paragraph-md">
        {t(
          'whyShouldIPayItForwardDescriptionYoungWashington',
          'Every year, more than 5 million middle and high school students study US History. We want every single one of them to experience the epic origin story of America’s greatest hero on the big screen. When you Pay it Forward, you make that possible for those young students who might not otherwise be able to see Young Washington. Help us give the rising generation the chance not just to learn our shared history, but feel it, experience it, and fall in love with it.',
        )}
      </Text>
    </div>
  )
}
